<template>
  <section>
    <div class="history">
      <History />
    </div>
    <div class="communicator">
      <div class="inner" :style="{ backgroundColor: visualSettings.bodyBackgroundColor }">
        <Communicator />
      </div>
      <div class="spacer"></div>
    </div>
    <div class="drawer" :class="{ open: drawerOpen }" :style="{ 
      backgroundColor: visualSettings.bodyBackgroundColor,
      borderLeftColor: visualSettings.channelHeaderBorderColor, 
      borderLeftWidth: visualSettings.channelHeaderBorderWidth
    }">
      <MessageDetail v-if="activeMessageId && drawerOpen" />
      <div class="overlay" @click="closeDrawer"></div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

import History from '@/components/History';
import Communicator from '@/components/Communicator';
import MessageDetail from '@/components/MessageDetail';

export default {
  name: 'Messenger',
  components: {
    History,
    Communicator,
    MessageDetail
  },
  data() {
    return {
      loaded: false
    }
  },
  computed: {
    ...mapGetters([
      'visualSettings'
    ]),
    ...mapState([
      'drawerOpen',
      'activeMessageId'
    ])
  },
  methods: {
    ...mapMutations([
      'setDrawerOpen'
    ]),
    closeDrawer() {
      this.setDrawerOpen(false);
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.loaded = true;
    // }, 1000);
  }
}
</script>

<style scoped lang="scss">
section {
  position: relative;
  width: 100%;
  height: 100%;
}

.history {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 60px;
}

.communicator {
  position: absolute;
  display: flex;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 0 0 0;
  height: 60px;
  z-index: 2;

  > .inner {
    flex: 1;
    padding: 0 20px 0 0;
    width: 100%;
    background: #fff;

    @media only screen and (max-width: 768px) {
      padding-right: 16px;
    }
  }

  .spacer {
    flex: 0 0 auto;
    opacity: 0;
    font-size: 0;
    height: 30px;
    scrollbar-color: rgba(0,0,0,0) rgba(0,0,0,0);
    position: relative;
    overflow-y: scroll;

    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
}

.drawer {
  position: absolute; 
  top: 0;
  left: 100%;
  bottom: 0;
  width: calc(100% - 100px);
  z-index: 2; 
  border-left: 1px solid #eaebef;
  box-sizing: border-box;
  box-shadow: 0 4px 16px rgba(60, 40, 40, 0.12);
    padding: 20px 20px 0;

  @media only screen and (max-width: 768px) {
    position: fixed;
    padding-left: 16px;
    padding-right: 16px;
  }

  transition: left 250ms ease-out;
  
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 100%;
    left: 0;
    opacity: 0;
    background: rgba(0,0,0,0.2);
    cursor: pointer;

    transition: opacity 250ms ease-out,
      left 1ms ease-out 250ms;
  }

  // &.loaded {
  //   left: 100%;
  //   width: calc(100% - 100px);
  // }

  &.open {
    left: 100px;

    .overlay {
      left: -1000px;
      opacity: 1;

      transition: opacity 250ms ease-out;
    }
  }
}
</style>
